/**
* @summary - Component that Provides Tab Content Layout
* @author Yuvasri S
* @since 2024-07-04
*/
import React from 'react';
import { Box, Button } from '@mui/material';

function TabContentLayout({ children }) {
  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { m: 0, width: '100%' },
      }}
      noValidate
      autoComplete="off"
    >
      {children}
    </Box>
  );
}

export default TabContentLayout;
